export default __webpack_public_path__ + "static/media/147.06e5118c.png";